import React, { useContext, useEffect } from "react";
import Pagination from "../../../components/pagination/Pagination";
import OnSellingContext from "../../../store/on_selling/OnSellingContext";
import OnSellingCard from "./OnSellingCard";

interface IProps {
  data: any;
}

const OnSellingList: React.FC<IProps> = ({ data }) => {
  const { onSellingDispatch } = useContext(OnSellingContext);
  useEffect(() => {
    onSellingDispatch({
      type: "set_default_size",
      payload: data?.data?.data.map((el: any) => ({
        size: el.selected_bnib_product_detail?.product_size?.size,
        id: el.selected_bnib_product_detail?.product_size_id
      })),
    });
    onSellingDispatch({
      type: "set_default_product",
      payload: data?.data?.data.map((el: any) => el.id),
    });
    onSellingDispatch({
      type: "set_default_seller",
      payload: data?.data?.data.map((el: any) => ({
        username: el.selected_bnib_product_detail?.seller?.username,
        id: el.selected_bnib_product_detail?.seller?.id,
      })),
    });
    onSellingDispatch({
      type: "set_default_status",
      payload: data?.data?.data.map(
        (el: any) => el?.selected_bnib_product_detail?.pre_order
      ),
    });
  }, [data]);

  if (data?.data?.data.length === 0) {
    return (
      <div className="flex justify-center h-24 w-full my-10">
        <div className="w-full h-full border rounded-md flex justify-center items-center">
          <h1>Empty Data</h1>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="w-full">
        {data?.data?.data.map((el: any, index: number) => (
          <OnSellingCard data={el} index={index} key={index} />
        ))}
      </div>
      <Pagination
        length={data?.data.data.length}
        total={data?.data.meta.total}
        isTable={false}
      />
    </div>
  );
};

export default OnSellingList;
